module.exports = __webpack_public_path__ + "static/media/trail.46bbfc2e.svg";